import React, { FC } from 'react'
import { Tab } from '@headlessui/react'
import { TabContent } from '../TabContent'
import { TabPanelsProps } from './types'

const MultiTabPanels: FC<{ tabs: TabPanelsProps['tabs'] }> = ({ tabs }) => (
  <>
    {tabs.map((tab) => (
      <Tab.Panel key={tab.title} className="w-full">
        <TabContent tab={tab} />
      </Tab.Panel>
    ))}
  </>
)

export const TabPanels: FC<TabPanelsProps> = ({ tabs }) => (
  <Tab.Panels className="w-full">
    <MultiTabPanels tabs={tabs} />
  </Tab.Panels>
)
